var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.ishome)?_c('img',{staticClass:"bg",attrs:{"src":require("@/assets/bg.png"),"alt":""}}):_vm._e(),_c('Header'),_c('div',{class:[{ 'svip': _vm.issvip }, 'main']},[_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }